export const environment = {
  prod: false,
  envName: 'dev',
  tenantId: '314', // tenantId/servicerId are used for the 'trigger', not used for authentication AT ALL
  servicerId: '2',
  envList: ['dev', 'qa', 'train', 'prod', 'uat'],
  loggerLevel: 'DEBUG', // DEBUG | TRACE | INFO | WARN | ERROR | FATAL
  apiUrl: 'https://development.nelnet.io',
  camundaUrl: 'https://camunda.nelnet.io', // used for portal configuration component
  contentBucket: 'systemconfig_dev/',   // CMS content s3 bucket, see more info on CMS on {{ https://confluence.glhec.org/confluence/display/VSDT/System+Config%2C+Agent+Portal+and+Ingeniux+CMS?src=contextnavpagetreemode }}
  authInterceptorWhitelist: [
    '/authapi/authenticate',
    '/loggingapi/logging/log',
    'https://qa.nelnet.io/loanprogramapi/loanprograms/full',
    'https://train.nelnet.io/loanprogramapi/loanprograms/full',
    'https://api.nelnet.io/loanprogramapi/loanprograms/full',
    'https://qa.nelnet.io/lenderapi/lenders',
    'https://train.nelnet.io/lenderapi/lenders',
    'https://api.nelnet.io/lenderapi/lenders',
    'https://qa.nelnet.io/brandapi/brands',
    'https://train.nelnet.io/brandapi/brands',
    'https://api.nelnet.io/brandapi/brands',
    'https://qa.nelnet.io/loanprogramapi/loanprograms/*',
    'https://qa.nelnet.io/loanprogramapi/loanprograms/',
    'https://qa.nelnet.io/loanprogramapi/loanprograms?lenderid=',
    'https://train.nelnet.io/loanprogramapi/loanprograms/*',
    'https://train.nelnet.io/loanprogramapi/loanprograms/',
    'https://train.nelnet.io/loanprogramapi/loanprograms?lenderid=',
    'https://api.nelnet.io/loanprogramapi/loanprograms/*',
    'https://api.nelnet.io/loanprogramapi/loanprograms/',
    'https://api.nelnet.io/loanprogramapi/loanprograms?lenderid=',
    'https://qa.nelnet.io/communicationsapi/communications/entity/lender/',
    'https://train.nelnet.io/communicationsapi/communications/entity/lender/',
    'https://api.nelnet.io/communicationsapi/communications/entity/lender/'
  ],
  // how soon before the token expires do we want to warn the user
  tokenExpiringWarnMs: 1 * 60 * 1000, // 1 min
  // the number of milliseconds the user has to click the button in the modal, once it is shown, before they are logged out for the token expiring
  tokenTimeoutWarnMs: 1 * 60 * 1000, // 1 min
  tokenTimeoutBufferMs: 1 * 20 * 1000 // 20 seconds
};
